import * as amplitude from '@amplitude/analytics-browser'
import { appConfig } from '@/shared/config/app-config'
import { composeUiSupport } from '@/shared/lib/compose-ui-support'
import { clearAnalyticsPlanFraming } from './plan-framing'

const DEVICE_ID_KEY = 'deviceID'
const STREAM = 'web'

let initialized = false

export function getDeviceId(): string {
  const { searchParams } = new URL(window.location.toString())
  const fromUrl = searchParams.get(DEVICE_ID_KEY)
  if (fromUrl) {
    localStorage.setItem(DEVICE_ID_KEY, fromUrl)
    return fromUrl
  }

  const stored = localStorage.getItem(DEVICE_ID_KEY)
  if (stored) return stored

  const generated = Math.random().toString(16).slice(2)
  localStorage.setItem(DEVICE_ID_KEY, generated)
  return generated
}

export function initAnalytics() {
  // Without a key, analytics stays off.
  if (initialized || !appConfig.amplitudeApiKey) return

  const deviceId = getDeviceId()

  amplitude.init(appConfig.amplitudeApiKey, {
    deviceId,
    identityStorage: 'localStorage',
    autocapture: {
      sessions: true,
      pageViews: false,
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: false,
    },
  })

  initialized = true
}

export function setAnalyticsUser(userId: string) {
  amplitude.setUserId(userId)
  const identify = new amplitude.Identify()
  identify.set('locale', navigator.language)
  // Every web user, not only an arm: the share that can run a Compose feature at all.
  identify.set('composeUiSupported', composeUiSupport().supported)
  amplitude.identify(identify)
}

export function setAnalyticsPracticePlayer(value: 'renewed' | 'legacy') {
  const identify = new amplitude.Identify()
  identify.set('practicePlayer', value)
  amplitude.identify(identify)
}

export function clearAnalyticsUser() {
  clearAnalyticsPlanFraming()
  amplitude.reset()
}

export function trackEvent(
  eventName: string,
  properties?: Record<string, unknown>,
) {
  const payload = { stream: STREAM, ...properties }
  amplitude.track(eventName, payload)
}
